<template>
  <div :class="['filter-container flex-row', dbOptionHeight]">
    <div class="filter-op">
      <ms-validate ref="validateObserver">
        <ms-validate ref="validateObserver">
          <menu-wrapper>
            <template #menu-button="{toggleMenu}">
              <button tabindex="-1" @click="toggleMenu" :class="['btn-filter-operator', dbOptionHeight]">
                <div :class="['icon24', nativeFilterIconClass]"></div>
              </button>
            </template>
            <template #menu-content>
              <template v-for="(item, i) in filterOperators" :key="i">
                <menu-item
                  class="filter-operator-item"
                  :class="item.enumValue === operatorValue ? 'active' : ''"
                  @menu-item-click="filterOperatorItemClick(item)"
                  :icon="['icon24', item.icon]"
                  >{{ item?.enumText }}</menu-item
                >
              </template>
            </template>
          </menu-wrapper>
        </ms-validate>
      </ms-validate>
    </div>
    <div class="filter-value flex">
      <ms-combobox-multiple
        v-model="filterValue"
        v-if="operatorValue == '=' || operatorValue == '!=' || col.formatType == 118"
        :displayField="propsData.suffixDisplayField ? propsData.displayField : col.displayField ?? col.dataField"
        :valueField="propsData.suffixDisplayField ? propsData.valueField : col.dataField"
        :suffixDisplayField="propsData.suffixDisplayField"
        v-model:display="displaySuffixValue"
        ref="thEnum"
        class="ms-input-filter-value"
        :title="col.tooltip || col.title || col.definition || col.caption"
        :isShowText="false"
        :data="propsData.data"
        :columns="propsData.columns"
        :dropdownWidth="propsData.dropdownWidth"
        :formatType="col.formatType"
        :queryMode="propsData.queryMode"
        @update:selected="selectComboboxBankTreasury"
        :filterSeachGrid="col.filterSeachGrid"
        @filterGrid="filterSeachGrids"
        :numberShowItem="col.numberShowItem ? col.numberShowItem : 3"
        @comboboxLoadData="
          payload =>
            onComboboxLoadData(payload, null, {
              dataField: col.dataField,
              sender: thEnum,
            })
        "
        @keydown.stop=""
        :hasBorder="false"
        :isGridEditor="isGridEditor"
        :is-reload="propsData.isReload"
      />
      <ms-input
        v-else
        ref="thEnum"
        v-model="filterValue"
        class="ms-input-filter-value"
        @keydown.stop=""
        :hasBorder="false"
      />
    </div>
  </div>
</template>
<script>
import {defineComponent, getCurrentInstance, ref} from 'vue';
import msThOptionBase from '@/components/gridViewer/columnOption/MsThOptionBase.js';
import setup from '@/components/gridViewer/columnOption/render-helper.js';
import MenuItem from '@/components/dropdown/MenuItem.vue';
import MenuWrapper from '@/components/dropdown/MenuWrapper.vue';
import MsComboboxMultiple from '@/components/combobox/MsComboboxMultiple.vue';
export default defineComponent({
  extends: msThOptionBase,
  components: {MenuItem, MenuWrapper, MsComboboxMultiple},
  name: 'MsThOptionComboboxMultiple',
  props: {
    filterIconClass: {
      type: String,
      default: 'ic-filter-contain',
    },
    propsData: {
      default: {},
      type: Object,
    },
    isGridEditor: {
      default: false,
      type: Boolean,
    },
    dbOptionHeight: {
      type: String,
    },
    // Nhận 2 giá trị remote/local để lấy giá trị ở server hoặc local
    queryMode: {
      default: 'remote',
      type: String,
    },
  },
  setup(props, {emit}) {
    const {proxy} = getCurrentInstance();
    /**
     * Giá trị hiển thị của filter
     * nnninh 01/12/2023
     */
    const displaySuffixValue = ref();

    //Khai báo data variable
    const {
      nativeFilterIconClass,
      operatorValue,
      filterValue,
      filterOperators,
      filterHeaderHandle,
      filterOperatorItemClick,
      removeFilter,
      thEnum,
    } = setup(props, {
      emit,
    });

    /**
     * Băn sự kiện loadData ra bên ngoài để gọi API
     * nnninh 01/12/2023
     */
    const onComboboxLoadData = async (payload, row, dataField) => {
      emit('load-filter-header', payload, row, dataField);
    };
    /**
     * Chọn tài khoản ngân hàng kho bạc thì bổ sung các trường để lấy lên store
     * nnninh 04/12/2023
     * @param {*} param0
     */
    const selectComboboxBankTreasury = newData => {
      let valData = newData.map(x => x[proxy.col.dataField]).join(';');
      proxy.filterHeaderHandle({
        operator:
          proxy.operatorValue === proxy.$ms.constant.FilterOperatorSearch.Equals && proxy.queryMode === 'remote' // Filter local chưa hỗ trợ toán tử IN nên vẫn dùng toán tử = rồi tự custom ndhieu3 26.11.2024
            ? proxy.$ms.constant.FilterOperatorSearch.In
            : proxy.operatorValue,
        value: valData,
      });
    };

    /**
     * Chọn tài khoản ngân hàng kho bạc thì bổ sung các trường để lấy lên store
     * nnninh 04/12/2023
     * @param {*} param0
     */
    const filterSeachGrids = val => {
      proxy.filterHeaderHandle({
        operator:
          proxy.operatorValue === proxy.$ms.constant.FilterOperatorSearch.Equals
            ? proxy.$ms.constant.FilterOperatorSearch.In
            : proxy.operatorValue,
        value: val,
      });
    };

    //Hooks
    return {
      nativeFilterIconClass,
      filterValue,
      operatorValue,
      filterOperators,
      filterOperatorItemClick,
      filterHeaderHandle,
      removeFilter,
      thEnum,
      onComboboxLoadData,
      displaySuffixValue,
      selectComboboxBankTreasury,
      filterSeachGrids,
    };
  },
});
</script>
